import React, { useState } from "react";
import { colors } from "../../../../themes/Colors";
import { BaseButtons, BaseButtonsIcon } from "../../../common-components";

const Menu = ({
  onUserClick,
  onVehicleClick,
  onBrandClick,
  onTaskClick,
  onShopperClick,
  onWebClick,
  onBuzzClick,
  onThirdPartyClick,
  onAgencyClick,
  onOffenseClick,
  selected,
  onRefreshClick,
}) => {
  const [shrink, setShrink] = useState(false);
  return (
    <div
      style={{
        height: "100%",
        width: shrink ? 85 : 210,

        transition: "all 0.4s",
        display: "flex",
        flexDirection: "column",
        backgroundColor: shrink ? colors.white : colors.white,
        paddingRight: 3,
        paddingLeft: 3,
        WebkitBoxShadow: "0px 0px 2px 2px #00000040",
        justifyContent: "flex-start",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <div onClick={() => setShrink(shrink ? false : true)}>
        <div
          style={{
            color: shrink ? colors.primaryBlue : colors.primaryBlue,
            fontSize: shrink ? 22 : 32,
            fontWeight: "bold",
            transition: "all 0.3s",
            marginLeft: shrink ? -5 : 0,
            marginTop: shrink ? 0 : 0,
            transform: shrink ? `rotate(90deg)` : null,
            cursor: "pointer",
            marginBottom: shrink ? 0 : 0,
          }}
        >
          <img
            alt="logo"
            src={
              shrink
                ? require("../../../../images/base-logo-desgns/driverfrinedIcon1.png")
                : require("../../../../images/base-logo-desgns/driverfrinedlogo4.png")
            }
            style={{ width: shrink ? 100 : "100%" }}
          />
        </div>
      </div>
      <BaseButtonsIcon
        selected={selected === "USERS" ? true : false}
        label={"USERS"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={
          selected === "USERS" ? colors.greenDark : colors.greenLight
        }
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/icons/usersWhite.png")}
        icon={require("../../../../images/icons/usersWhite.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink ? 18 : shrink}
        shrinkColor={
          selected === "USERS" ? colors.greenDark : colors.greenLight
        }
        hoverColor={colors.greenDark}
        onClick={onUserClick}
      />
      <BaseButtonsIcon
        label={"VEHICLES"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={
          selected === "VEHICLES" ? colors.greenDark : colors.greenLight
        }
        borderRadius={shrink ? 3 : 5}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink}
        marginTop={shrink ? 2 : 2}
        shrinkColor={
          selected === "VEHICLES" ? colors.greenDark : colors.greenLight
        }
        hoverColor={colors.greenDark}
        icon2={require("../../../../images/material-icon/whiteVehicle.png")}
        icon={require("../../../../images/material-icon/whiteVehicle.png")}
        onClick={onVehicleClick}
      />
      <BaseButtonsIcon
        //disable={true}
        label={"OFFENCE"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={
          selected === "OFFENCE" ? colors.greenDark : colors.greenLight
        }
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/material-icon/whiteOffence.png")}
        icon={require("../../../../images/material-icon/whiteOffence.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink}
        marginTop={2}
        shrinkColor={
          selected === "OFFENCE" ? colors.greenDark : colors.greenLight
        }
        hoverColor={colors.greenDark}
        onClick={onOffenseClick}
      />
      <BaseButtonsIcon
        label={"TASKS"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={
          selected === "TASKS" ? colors.greenDark : colors.greenLight
        }
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/material-icon/whiteMarker.png")}
        icon={require("../../../../images/material-icon/whiteMarker.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink}
        marginTop={2}
        shrinkColor={
          selected === "TASKS" ? colors.greenDark : colors.greenLight
        }
        hoverColor={colors.greenDark}
        onClick={onTaskClick}
      />
      <BaseButtonsIcon
        label={"AGENCIES"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={
          selected === "AGENCY" ? colors.greenDark : colors.greenLight
        }
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/material-icon/whiteBuzz.png")}
        icon={require("../../../../images/material-icon/whiteBuzz.png")}
        iconHeight={shrink ? 40 : 37}
        iconWidth={shrink ? 40 : 37}
        shrink={shrink}
        marginTop={2}
        shrinkColor={
          selected === "AGENCY" ? colors.greenDark : colors.greenLight
        }
        hoverColor={colors.greenDark}
        onClick={onAgencyClick}
      />
      <BaseButtonsIcon
        label={"BUZZ"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={colors.greenLight}
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/material-icon/whiteBee.png")}
        icon={require("../../../../images/material-icon/whiteBee.png")}
        iconHeight={shrink ? 40 : 37}
        iconWidth={shrink ? 40 : 37}
        shrink={shrink}
        marginTop={2}
        shrinkColor={colors.greenDark}
        hoverColor={colors.greenDark}
        onClick={onBuzzClick}
      />
      <BaseButtonsIcon
        label={"THIRD PARTY"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={colors.greenLight}
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/icons/storeWhite.png")}
        icon={require("../../../../images/icons/storeWhite.png")}
        iconHeight={shrink ? 40 : 37}
        iconWidth={shrink ? 40 : 37}
        shrink={shrink}
        marginTop={2}
        shrinkColor={colors.greenDark}
        hoverColor={colors.greenDark}
        onClick={onThirdPartyClick}
      />
      <BaseButtonsIcon
        disable={true}
        label={"WHITE LABEL"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={colors.greenLight}
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/material-icon/whiteBuzz.png")}
        icon={require("../../../../images/material-icon/whiteBuzz.png")}
        iconHeight={shrink ? 40 : 37}
        iconWidth={shrink ? 40 : 37}
        shrink={shrink}
        marginTop={2}
        shrinkColor={colors.greenDark}
        hoverColor={colors.greenDark}
        onClick={onShopperClick}
      />
      <BaseButtonsIcon
        label={"WEB MANAGER"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={colors.greenLight}
        borderRadius={shrink ? 3 : 5}
        icon2={require("../../../../images/icons/webManagerWhite.png")}
        icon={require("../../../../images/icons/webManagerWhite.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink}
        marginTop={shrink ? 2 : 2}
        shrinkColor={colors.greenDark}
        hoverColor={colors.greenDark}
        onClick={onWebClick}
      />
      <BaseButtonsIcon
        label={"REFRESH"}
        width={shrink ? "100%" : "100%"}
        backgroundColor={colors.orangeDark}
        borderRadius={shrink ? 3 : 5}
        // icon2={require("../../../../images/icons/webManagerWhite.png")}
        // icon={require("../../../../images/icons/webManagerWhite.png")}
        iconHeight={shrink ? 40 : 35}
        iconWidth={shrink ? 40 : 35}
        shrink={shrink}
        marginTop={shrink ? 2 : 2}
        shrinkColor={colors.orangeDark}
        hoverColor={colors.primaryOrange}
        onClick={onRefreshClick}
      />
    </div>
  );
};

export default Menu;
